import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ae6083"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff-page mt-5" }
const _hoisted_2 = { class: "field grid input-component" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "namekanji",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 required flex justify-content-start"
}, " 氏名（漢字） ", -1))
const _hoisted_4 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_5 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_6 = { class: "field grid input-component" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "namekana",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 required flex justify-content-start"
}, " 氏名（カナ) ", -1))
const _hoisted_8 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_9 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_10 = { class: "field grid input-component" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 required flex justify-content-start"
}, " メールアドレス ", -1))
const _hoisted_12 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_13 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_14 = { class: "field grid input-component" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "image-url",
  class: "lg:col-2 md:col-12 sm:col-12 flex justify-content-start"
}, "イメージ画像 ", -1))
const _hoisted_16 = { class: "col-2 w-13rem upload-image" }
const _hoisted_17 = {
  key: 0,
  class: "card h-full relative border-1 surface-border"
}
const _hoisted_18 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "h-9rem w-full" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "h-auto w-full align-items-center justify-content-center" }
const _hoisted_25 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_26 = ["alt", "src"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "block p-error text-sm col-offset-2"
}
const _hoisted_29 = { class: "field grid input-component" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "namekana",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, " 同時予約可能件数 ", -1))
const _hoisted_31 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_32 = { class: "field grid input-component" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "treatment-history",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, " 施術歴 ", -1))
const _hoisted_34 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_35 = { class: "field grid input-component" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "treatment-history",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, " 役職 ", -1))
const _hoisted_37 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_38 = { class: "field grid input-component" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "comments",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, " コメント ", -1))
const _hoisted_40 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_41 = { class: "field grid input-component" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "special-treatment",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, " 得意な施術 ", -1))
const _hoisted_43 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_44 = { class: "field grid input-component" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "order-price",
  class: "lg:col-2 md:col-12 sm:col-12 mb-2 flex justify-content-start"
}, "指名料", -1))
const _hoisted_46 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "円", -1))
const _hoisted_48 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_49 = { class: "submit mt-5 mb-8 lg:col-6 md:col-12 sm:col-12" }
const _hoisted_50 = { class: "flex justify-content-end" }

import { IStaff, ApiStaffDetailRes } from "@/clinic/typings";
import { MaybeRefOrGetter, get, set } from "@vueuse/core";
import { ref, withDefaults, reactive, computed, onBeforeMount } from "vue";
import { Rule, Rules, ValidateError } from "async-validator";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { useCookies } from "@vueuse/integrations/useCookies";
import { useRoute } from "vue-router";
import { useToast } from "primevue/usetoast";
import * as _ from "lodash";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import axios from "axios";
import FileUpload from "primevue/fileupload";
import InputText from "primevue/inputtext";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import Toast from "primevue/toast";
import Dropdown from "primevue/dropdown";

type IForm = {
  clinicId: number;
  hasEdit?: boolean;
  model?: IStaff | ApiStaffDetailRes;
  rules: MaybeRefOrGetter<Record<string, Rule | Rules>>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    clinicId: null,
    hasEdit: { type: Boolean, default: false },
    model: { default: {} as IStaff | ApiStaffDetailRes },
    rules: null
  },
  setup(__props: any) {

const props = __props as { clinicId: number, hasEdit: boolean, model: IStaff | ApiStaffDetailRes, rules: MaybeRefOrGetter<Record<string, Rule | Rules>> };

const toast = useToast();
const route = useRoute();

const inputUploadImage = ref();
const loading = ref(false);
const maxNumberOfBookings = ref(1);



const form = reactive<IStaff | ApiStaffDetailRes>({
  id: 0,
  clinic_id: 0,
  name_kanji: "",
  name_kana: "",
  email: "",
  avatar: "",
  avatar_url: "",
  treatment_history: "",
  position: "",
  comments: "",
  special_treatments: "",
  order_price: 0,
  maxNumberOfBookings: 1,
});
const showImage = () => {
  let reader = new FileReader();
  reader.readAsDataURL(get(inputUploadImage).files[0]);
  reader.onload = evt => {
    let img: any | null = null;
    img = new Image();
    img.src = evt.target?.result;
  };
};

const initValidation = computed(() => {
  return useAsyncValidator({ ...form, inputUploadImage }, props.rules);
});

const backToList = () => RouterUtils.goTo(RouterConstants.STAFF_LIST_ROUTER_NAME);

const validate = async (): Promise<boolean> => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const formRef = ref<HTMLFormElement>();
const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);

const handleSaveButton = async () => {
  set(loading, true);
  const valid = await validate();

  if (!valid) {
    set(loading, false);
    return;
  }

  const { get: getCookie } = useCookies();
  const token = getCookie("access_token");

  var formData = new FormData();
  formData.append("name_kanji", get(form.name_kanji));
  formData.append("name_kana", get(form).name_kana);
  formData.append("email", get(form).email);
  formData.append("max_number_of_bookings", get(form).maxNumberOfBookings);

  if (get(form).treatment_history != undefined) {
    formData.append("treatment_history", get(form).treatment_history);
  }

  if (get(form).position != undefined) {
    formData.append("position", get(form).position);
  }

  if (get(form).comments != undefined) {
    formData.append("comments", get(form).comments);
  }

  if (get(form).special_treatments != undefined) {
    formData.append("special_treatments", get(form).special_treatments);
  }

  if (get(form).order_price != undefined) {
    formData.append("order_price", get(form).order_price);
  }

  if (get(inputUploadImage)?.files[0] != undefined) {
    formData.append("avatar", get(inputUploadImage)?.files[0]);
  }

  if (props.hasEdit) {
    const urlEndpoint = `${ApiRouterConstants?.API_STAFFS}/${route.params.id}?clinic_id=${props.clinicId}`;
    axios
      .patch(urlEndpoint, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      })
      .then(() => {
        RouterUtils.goTo(RouterConstants.STAFF_LIST_ROUTER_NAME);
      })
      .catch(error => {
        loading.value = false;

        if (error.response && error.response.data && error.response.data.errors) {
          toast.add({
            severity: "error",
            detail: error.response.data.errors.join("\n"),
            life: 3000,
          });
        }
      });
  } else {
    const urlEndpoint = `${ApiRouterConstants?.API_STAFFS}?clinic_id=${props.clinicId}`;
    axios
      .post(urlEndpoint, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      })
      .then(() => {
        RouterUtils.goTo(RouterConstants.STAFF_LIST_ROUTER_NAME);
      })
      .catch(error => {
        loading.value = false;

        if (error.response && error.response.data && error.response.data.errors) {
          toast.add({
            severity: "error",
            detail: error.response.data.errors.join("\n"),
            life: 3000,
          });
        }
      });
  }
};

const loadModel = () => {
  form.clinic_id = props.clinicId as unknown as number;
  if (!props.hasEdit || !props.model?.id || props.model?.id == form.id) return;
  const {
    id,
    clinic_id,
    name_kanji,
    name_kana,
    email,
    avatar_url,
    max_number_of_bookings: maxNumberOfBookings,
    position,
    comments,
    special_treatments,
    treatment_history,
    order_price,
  } = props.model as ApiStaffDetailRes;
  const updateProps = {
    id,
    clinic_id,
    name_kanji,
    name_kana,
    email,
    avatar_url,
    maxNumberOfBookings,
    position,
    comments,
    special_treatments,
    treatment_history,
    order_price,
  };
  Object.assign(form, updateProps);
};

onBeforeMount(async () => loadModel());

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "form-wrapper",
        ref_key: "formRef",
        ref: formRef
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(InputText), {
              id: "namekanji",
              class: "w-100",
              modelValue: form.name_kanji,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name_kanji) = $event)),
              placeholder: "氏名を入力してください（20字）"
            }, null, 8, ["modelValue"]),
            (errorFields.value?.name_kanji)
              ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_.head(errorFields.value.name_kanji)?.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(InputText), {
              id: "namekana",
              class: "w-100",
              modelValue: form.name_kana,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name_kana) = $event)),
              placeholder: "氏名を入力してください（20字）"
            }, null, 8, ["modelValue"]),
            (errorFields.value?.name_kana)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_.head(errorFields.value.name_kana)?.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(InputText), {
              id: "email",
              class: "w-100",
              modelValue: form.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
              placeholder: "メールアドレスを入カしてください"
            }, null, 8, ["modelValue"]),
            (errorFields.value?.email)
              ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_.head(errorFields.value.email)?.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (form.avatar_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      role: "presentation",
                      src: form.avatar_url,
                      width: "150",
                      class: "shadow-2 mt-2 mb-2"
                    }, null, 8, _hoisted_19)
                  ]),
                  _createElementVNode("i", {
                    class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (form.avatar_url = ''))
                  })
                ]))
              : (_openBlock(), _createBlock(_unref(FileUpload), {
                  key: 1,
                  id: "upload",
                  class: "file-upload",
                  accept: "image/png, image/jpeg",
                  ref_key: "inputUploadImage",
                  ref: inputUploadImage,
                  onChange: showImage,
                  type: "file",
                  fileLimit: 1
                }, {
                  header: _withCtx(({ files, chooseCallback }) => [
                    _withDirectives(_createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        class: "fake-btn h-9rem w-full flex align-items-center justify-content-center",
                        onClick: ($event: any) => (chooseCallback())
                      }, _hoisted_23, 8, _hoisted_21)
                    ], 512), [
                      [_vShow, files.length <= 0]
                    ])
                  ]),
                  content: _withCtx(({ files, removeFileCallback }) => [
                    _withDirectives(_createElementVNode("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: file.name + file.type + file.size,
                          class: "card h-full relative border-1 surface-border"
                        }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("img", {
                              role: "presentation",
                              alt: file.name,
                              src: file.objectURL,
                              width: "150",
                              class: "shadow-2 mt-2 mb-2"
                            }, null, 8, _hoisted_26)
                          ]),
                          _createElementVNode("i", {
                            class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                            onClick: ($event: any) => (removeFileCallback(index))
                          }, null, 8, _hoisted_27)
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, files.length > 0]
                    ])
                  ]),
                  _: 1
                }, 512))
          ])
        ]),
        (errorFields.value?.inputUploadImage && inputUploadImage.value?.files?.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_.head(errorFields.value.inputUploadImage)?.message), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_unref(Dropdown), {
              modelValue: form.maxNumberOfBookings,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.maxNumberOfBookings) = $event)),
              options: [1, 2, 3, 4, 5],
              class: "w-full md:w-14rem"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_Textarea, {
              modelValue: form.treatment_history,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.treatment_history) = $event)),
              type: "text",
              size: "large",
              name: "treatment-history",
              rows: "6",
              cols: "30",
              placeholder: "施術歴 (300字)",
              class: "w-100"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_unref(InputText), {
              id: "treatment-history",
              class: "w-100",
              modelValue: form.position,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.position) = $event)),
              placeholder: "役職（50字）"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_Textarea, {
              modelValue: form.comments,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.comments) = $event)),
              "aria-describedby": "description-help",
              type: "text",
              size: "large",
              name: "comments",
              rows: "6",
              cols: "30",
              placeholder: "コメント (300字)",
              class: "w-100"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_unref(InputText), {
              id: "special-treatment",
              class: "w-100",
              modelValue: form.special_treatments,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.special_treatments) = $event)),
              placeholder: "得意な施術（50字）"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_unref(InputText), {
              modelValue: form.order_price,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.order_price) = $event)),
              type: "number",
              size: "large",
              name: "order_price",
              class: "w-full md:w-14rem"
            }, null, 8, ["modelValue"]),
            _hoisted_47,
            (errorFields.value?.orderPrice)
              ? (_openBlock(), _createElementBlock("small", _hoisted_48, _toDisplayString(_.head(errorFields.value.orderPrice)?.message), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_Button, {
            label: "キャンセル",
            class: "p-button-light m-0 mr-3",
            onClick: backToList
          }),
          _createVNode(_component_Button, {
            type: "button",
            class: "btn-orange m-0",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (handleSaveButton())),
            label: "保存する",
            loading: loading.value
          }, null, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})